export const GET_PROMO_EBOOK = 'GET_PROMO_EBOOK';
export const SET_PROMO_EBOOK = 'SET_PROMO_EBOOK';
export const ERROR_PROMO_EBOOK = 'ERROR_PROMO_EBOOK';